import { defineNuxtRouteMiddleware, navigateTo, useRoute } from '#imports'

export default defineNuxtRouteMiddleware((to, from) => {
	// Handle URL replacement for staging and production environments
	if (window.document.location.href.includes('staging.wewiink.com')) {
		window.location.href = window.document.location.href.replace(
			'staging.wewiink.com',
			'staging.loyoly.io',
		)
	}
	if (window.document.location.href.includes('app.wewiink.com')) {
		window.location.href = window.document.location.href.replace(
			'app.wewiink.com',
			'app.loyoly.io',
		)
	}

	// Define the path redirections
	const redirections = {
		'/dashboard/content': '/contents/library',
		'/rewards': '/rewards/list',
		'/actions/rewards': '/rewards/send',
		'/rewards/sent': '/rewards/send',
		'/program': '/programs/missions',
		'/programs': '/programs/missions',
		'/missions': '/programs/missions',
		'/actions/applications': '/seeding/applications',
		'/branding': '/branding/space',
		'/seeding': '/seeding/campaigns',
		'/actions/rewards/gifting': '/seeding/send',
		'/ambassadors': '/ambassadors/crm',
		'/dashboard/home': '/home',
		'/diffusion': '/communication/diffusion',
		'/programs/loyalty': '/programs/missions',
	}

	const redirectPath = redirections[to.path]

	if (redirectPath) {
		return navigateTo(redirectPath) // Perform the redirect
	}
	return
})
